<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput :option="{placeholder:'分类名称',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;}
                        if(val.type=='keydown') GetCateList();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetCateList()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'新增分类'}" 
                    @finish="(val)=>{
                        var navinfo={name:'新增教程分类',labelentry:'AddPlatFormVideoCate',components:'AddPlatFormVideoCate',isshow:false};
                        var data={Method:''};
                        var obj={nav:navinfo,data:data};
                        this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
                    }" 
                />
            </el-form-item>
            <el-form-item style="position:absolute;right:0;">
            <div class="TTL-switch" style="display:inline-flex;align-items:center;height:60px;">
            <el-switch v-model="param.type" active-text="按二级分类搜索" 
                @change="(val)=>{
                    this.param.key='';
                    this.param.change=true;
                    GetCateList();
                }" 
            />
            </div>
            </el-form-item>
        </el-form>
    </div>

    <!-- 一级分类 --> 
    <div class="TTL-table top20" id="table-plat-cate-obj" v-if="param.type==0">
        <el-table :data="catelist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="分类名称" prop="name" align="center" />
            <el-table-column label="排序" align="center">
                <template #default="scope">
                    <div class="TTL-sort">
                    <wcinput :value="scope.row.sort" :option="{placeholder:'请填写排序方式',type:'input',width:120,ischange:true}"  
                        @finish="(val)=> {
                            if(val.type=='change') ChangeSort(scope.row.id,val.value);
                        }"
                    />
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="GetCateInfo(scope.row.id)" />
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DeleCate(scope.row.id)" class="left10"/>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <!-- 二级分类 --> 
    <div class="TTL-table top20" id="table-plat-cate-obj" v-if="param.type==1">
        <el-table :data="catelist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="分类名称" prop="name" align="center" />
            <el-table-column label="一级分类" prop="pcatename" align="center" />
            <el-table-column label="排序" align="center">
                <template #default="scope">
                    <div class="TTL-sort">
                    <wcinput :value="scope.row.sort" :option="{placeholder:'请填写排序方式',type:'input',width:120,ischange:true}"  
                        @finish="(val)=> {
                            if(val.type=='change') {
                                ChangeSort(scope.row.id,val.value);
                                scope.row.sort=val.value;
                            }
                        }"
                    />
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="GetCateInfo(scope.row.id)" />
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DeleCate(scope.row.id)" class="left10"/>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <!-- 分页 -->
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <wcselect 
                    :list="handleinfos"
                    :option="{placeholder:'请选择操作',ischange:true,isconfim:true}" 
                    @finish="(val)=> {
                        var ids=GetSelectDataIds(); //获取勾选的数据ids
                        if(ids.length==0 && (val.value==1 || val.value==2)) { //没有勾选id
                            $notice({title:'错误提示',type:'warning',message:'请勾选要操作的数据'});

                        }else if(val.value==1) { //批量删除账号
                            ids=ids.join(',');
                            DeleCate(ids);

                        }else if(val.value==2) { //批量编辑账号
                            ids=ids.join(',');
                            GetCateInfo(ids);

                        }
                    }"
                />
            </div>
            <wcpage 
                :pagerow="param.row" 
                :p="param.p" 
                :rollpage="param.rollpage"  
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetCateList();
                }"
            />
            
        </div>
    </div>
    

</template>

<script>
import INTERFACE_MODEL_PLAT_VEDIO from '@/Interface/Platsetting/PlatVedio';
export default {
    components:{},
    data() {
        return {
            refobj:'platvedioobj',
            param: {
                type:false,
                key:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            catelist:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除账号'},
                {id:2,name:'批量编辑账号'},
            ],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetCateList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.GetCateList();
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.GetCateList();
            }else {
                this.GetCateList();
            }
        },


        /** 获取分类信息列表 **/
        GetCateList() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-plat-cate-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_PLAT_VEDIO.GET_CATE_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.catelist=res.data.list;
            });
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.catelist.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.catelist.length;i++) this.catelist[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.catelist);
        },


        /** 删除数据 **/
        DeleCate(ids) {
            INTERFACE_MODEL_PLAT_VEDIO.DEL_CATE_INFO({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.ischange=true;
                 this.GetCateList();
            });
        },


        /** 获取分类数据 **/
        GetCateInfo(ids) {
            var navinfo={name:'编辑使用教程分类',labelentry:'EditPlatFormVideoCate',components:'EditPlatFormVideoCate',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 修改分类排序 **/
        ChangeSort(id,sort) {
            INTERFACE_MODEL_PLAT_VEDIO.Edit_CATE_SORT({id:id,sort:sort}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetCateList();
            });
        }

    },
}
</script>
<style scoped>
.TTL-btn-list {display: inline-flex;justify-content: center;}
.TTL-sort {display: inline-flex;justify-content: center}
</style>